<template>
  <b-card
    no-body
    class="form-coverage-ro-page p-2 p-md-3 bg-white"
  >
    <!-- Header Title & Back Button -->
    <div class="d-flex align-items-center pb-2 mb-2 border-bottom-subtle">
      <button
        type="button"
        class="btn-back mr-2"
        @click="$router.go(-1)"
      >
        <feather-icon
          icon="ChevronLeftIcon"
          size="20"
        />
      </button>
      <h4 class="page-title m-0">
        Ubah Coverage Area
      </h4>
    </div>

    <!-- Main Form Card Container -->
    <div class="form-container-card">
      <b-row>
        <!-- Provinsi -->
        <b-col
          cols="12"
          md="6"
          class="mb-3"
        >
          <label class="form-field-label">Provinsi</label>
          <v-select
            v-model="province"
            :reduce="option => option.label"
            :options="provinceList"
            class="custom-vselect"
            :filterable="true"
            :clearable="false"
            placeholder="Cari provinsi"
            @input="searchCity"
          />
        </b-col>

        <!-- Kabupaten/Kota -->
        <b-col
          cols="12"
          md="6"
          class="mb-3"
        >
          <label class="form-field-label">Kabupaten/Kota</label>
          <v-select
            v-model="city"
            label="city"
            :reduce="option => option.city"
            :options="cityList"
            class="custom-vselect"
            :filterable="true"
            :clearable="false"
            :disabled="province === ''"
            placeholder="Cari kabupaten/kota"
          />
        </b-col>

        <!-- Ekspedisi -->
        <b-col
          cols="12"
          md="6"
          class="mb-3"
        >
          <label class="form-field-label">Ekspedisi</label>
          <v-select
            v-model="shipping"
            :options="expeditionsList"
            :clearable="false"
            class="custom-vselect"
            placeholder="Pilih ekspedisi"
          />
        </b-col>

        <!-- Upload File -->
        <b-col
          cols="12"
          md="6"
          class="mb-3"
        >
          <label class="form-field-label">Upload File</label>
          <div
            class="custom-file-upload-box"
            @click="handleClickUpload"
          >
            <input
              id="uploadFile"
              ref="uploadFile"
              type="file"
              accept=".csv, .xlsx, .xls"
              class="d-none"
              @change="handleFileChange"
            >
            <div
              v-if="uploadFile"
              class="file-info-display text-truncate"
            >
              <span class="file-name text-truncate text-dark font-medium">
                {{ uploadFile.name }}
              </span>
              <span class="file-size text-muted ml-1 flex-shrink-0">
                ({{ formatFileSize(uploadFile.size) }})
              </span>
            </div>
            <span
              v-else
              class="file-name-display text-truncate placeholder-text"
            >
              Upload File
            </span>
            <div class="d-flex align-items-center h-100">
              <button
                v-if="uploadFile"
                type="button"
                class="btn-reset-file mr-1"
                @click.stop="resetUpload"
              >
                <feather-icon
                  icon="XIcon"
                  size="14"
                />
              </button>
              <button
                type="button"
                class="btn-browse"
                @click.stop="handleClickUpload"
              >
                Browse
              </button>
            </div>
          </div>
        </b-col>

        <!-- Keterangan -->
        <b-col
          cols="12"
          class="mb-1"
        >
          <label class="form-field-label">Keterangan</label>
          <b-form-textarea
            id="keterangan"
            v-model="description"
            rows="4"
            maxlength="100"
            placeholder="Tulis keterangan disini"
            class="custom-textarea"
          />
          <div class="d-flex justify-content-end mt-1">
            <small class="char-counter">{{ description.length }}/100</small>
          </div>
        </b-col>
      </b-row>
    </div>

    <!-- Bottom Submit Button -->
    <div class="d-flex justify-content-end mt-4">
      <b-button
        :disabled="disabled() || loadingSubmit"
        class="btn-submit"
        @click.prevent="submit()"
      >
        <b-spinner
          v-if="loadingSubmit"
          small
          class="mr-1"
        />
        <span v-else>Ajukan File Local</span>
      </b-button>
    </div>
  </b-card>
</template>

<script>
import VSelect from 'vue-select'
import { mapState } from 'vuex'
import '@core/scss/vue/libs/vue-select.scss'
import { listProvince } from './config'

export default {
  components: {
    VSelect,
  },
  data() {
    return {
      loadingSubmit: false,
      province: '',
      provinceList: listProvince,
      city: '',
      cityList: [],
      shipping: '',
      uploadFile: null,
      description: '',
      expeditionsList: [],
    }
  },
  computed: {
    ...mapState('filter', ['expeditionList']),
  },
  mounted() {
    if (this.expeditionList.length === 0) {
      this.$store.dispatch('filter/getUpdateExpedition')
    }
    this.expeditionsList = this.expeditionList.map(item => item.shipping_name)
  },
  methods: {
    searchCity() {
      const params = {
        province: this.province,
      }
      this.$http_new.get('/komship/api/v1/admin/coverage-area/city-by-province', { params })
        .then(res => {
          const { data } = res.data
          this.cityList = data
        })
        .catch(err => {
          this.$toast_error({ message: 'Tidak mendapatkan list kota' || err?.response?.data?.message })
        })
    },
    formatFileSize(bytes) {
      if (!bytes && bytes !== 0) return ''
      if (bytes < 1024) return `${bytes} B`
      if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
      return `${(bytes / (1024 * 1024)).toFixed(2)} MB`
    },
    async handleFileChange() {
      const fileExcel = this.$refs.uploadFile.files[0]
      if (!fileExcel) return

      // Validasi format file (.csv, .xlsx)
      const allowedExtensions = ['csv', 'xlsx', 'xls']
      const fileExtension = fileExcel.name.split('.').pop().toLowerCase()
      if (!allowedExtensions.includes(fileExtension)) {
        this.$toast_error({ message: 'Format file harus berupa CSV (.csv) atau XLSX (.xlsx)' })
        this.resetUpload()
        return
      }

      // Validasi maksimal 5MB
      const maxSizeMB = 5
      const maxSizeBytes = maxSizeMB * 1024 * 1024

      if (fileExcel.size > maxSizeBytes) {
        this.$toast_error({ message: 'Ukuran file melebihi 5MB' })
        this.resetUpload()
        return
      }

      this.uploadFile = fileExcel
    },
    handleClickUpload() {
      document.getElementById('uploadFile').click()
    },
    resetUpload() {
      this.$refs.uploadFile.value = ''
      this.uploadFile = null
    },
    async submit() {
      this.loadingSubmit = true
      const formData = new FormData()
      formData.append('city', this.city)
      formData.append('shipping', this.shipping)
      formData.append('note', this.description)
      formData.append('coverage_file', this.uploadFile)
      formData.append('source', 'rajaongkir')

      this.$http_new.post('/komship/api/v1/admin/coverage-area', formData)
        .then(res => {
          this.loadingSubmit = false
          this.$toast_success({ message: 'Berhasil Ubah Coverage Area!' })
          this.$router.push('/coverage-area')
        })
        .catch(err => {
          this.loadingSubmit = false
          this.$toast_error({ message: 'Gagal Ubah Coverage Area!' || err?.response?.data?.message })
        })
    },
    disabled() {
      return this.province === '' || this.city === '' || this.shipping === '' || !this.uploadFile || this.description === ''
    },
  },
}
</script>

<style lang="scss" scoped>
.form-coverage-ro-page {
  border-radius: 8px;
  border: none;
}

.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
}

.border-bottom-subtle {
  border-bottom: 1px solid #f1f1f4;
}

.btn-back {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  color: #4b5563;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;

  &:hover {
    background-color: #f9fafb;
    border-color: #d1d5db;
    color: #111827;
  }

  &:focus {
    outline: none;
  }
}

.form-container-card {
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 24px;
}

.form-field-label {
  font-size: 13px;
  font-weight: 500;
  color: #1f2937;
  margin-bottom: 8px;
  display: block;
}

/* Custom VSelect */
::v-deep .custom-vselect {
  .vs__dropdown-toggle {
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 3px 8px;
    min-height: 40px;
    background-color: #ffffff;
    transition: border-color 0.2s ease;
  }

  &.vs--open .vs__dropdown-toggle {
    border-color: #f95031;
  }

  .vs__selected {
    color: #1f2937;
    font-size: 13px;
  }

  .vs__search {
    font-size: 13px;
    color: #1f2937;
    margin: 4px 0 0 0;
    padding: 0 4px;

    &::placeholder {
      color: #9ca3af;
    }
  }

  .vs__actions {
    padding-top: 0;
  }

  .vs__open-indicator {
    fill: #6b7280;
    transform: scale(0.75);
  }

  &.vs--disabled .vs__dropdown-toggle {
    background-color: #f9fafb;
    cursor: not-allowed;
  }
}

/* Custom File Upload Box */
.custom-file-upload-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background-color: #ffffff;
  overflow: hidden;
  cursor: pointer;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: #d1d5db;
  }

  .file-name-display {
    padding-left: 12px;
    font-size: 13px;
    color: #1f2937;
    flex: 1;

    &.placeholder-text {
      color: #9ca3af;
    }
  }

  .file-info-display {
    padding-left: 12px;
    padding-right: 8px;
    display: flex;
    align-items: center;
    font-size: 13px;
    flex: 1;
    min-width: 0;

    .file-name {
      max-width: calc(100% - 75px);
    }

    .file-size {
      font-size: 12px;
      color: #6b7280;
      white-space: nowrap;
    }
  }

  .btn-browse {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 0 16px;
    background-color: #f3f4f6;
    border: none;
    border-left: 1px solid #e5e7eb;
    color: #374151;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.15s ease;

    &:hover {
      background-color: #e5e7eb;
    }

    &:focus {
      outline: none;
    }
  }

  .btn-reset-file {
    background: transparent;
    border: none;
    color: #9ca3af;
    padding: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    outline: none;

    &:hover {
      color: #ef4444;
    }
  }
}

/* Custom Textarea */
.custom-textarea {
  border: 1px solid #e5e7eb !important;
  border-radius: 8px !important;
  padding: 10px 14px !important;
  font-size: 13px !important;
  color: #1f2937 !important;
  resize: vertical;

  &::placeholder {
    color: #9ca3af !important;
  }

  &:focus {
    border-color: #f95031 !important;
    box-shadow: 0 0 0 2px rgba(249, 80, 49, 0.1) !important;
  }
}

.char-counter {
  font-size: 12px;
  color: #9ca3af;
}

/* Submit Button */
.btn-submit {
  background-color: #f95031 !important;
  border-color: #f95031 !important;
  color: #ffffff !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  padding: 10px 24px !important;
  box-shadow: none !important;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background-color: #e04020 !important;
    border-color: #e04020 !important;
  }

  &:disabled {
    background-color: #d1d5db !important;
    border-color: #d1d5db !important;
    color: #ffffff !important;
    cursor: not-allowed;
    opacity: 0.7;
  }
}
</style>
